var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Alert from '@lendi-ui/alert';
import { mb } from '@lendi-ui/spacing';
import { Link } from '@lendi-ui/typography';
import * as React from 'react';
import styled from 'styled-components';
export var AlertError = function (_a) {
    var error = _a.error;
    return (error && (React.createElement(AlertWrapper, { "data-testid": "errorMessage", variant: "error" },
        React.createElement(React.Fragment, null,
            error.description,
            error && error.contactUs && (React.createElement(React.Fragment, null,
                ' ',
                "Please",
                ' ',
                React.createElement(Link, { "data-testid": "contactUs", href: "/contactus", color: "error.500" }, "contact us"),
                ' ',
                "to proceed."))))));
};
export var AlertWrapper = styled(Alert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), mb('sm'));
var templateObject_1;
//# sourceMappingURL=index.js.map